import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#08203f] text-white" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="max-w-[1320px] w-[calc(100%-40px)] mx-auto px-4 py-3 md:py-4">
        <div className="flex flex-col items-center text-center">
          <Link to="/" className="flex items-center gap-1.5">
            <img
              src="https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/aac10704-c5ad-4b55-a2c3-0c294889f163/1784770864829-dt7lq8.png"
              alt="Dallas Desi Scoop"
              className="h-9 w-auto object-contain"
            />
            <span className="text-[22px] font-bold tracking-tight leading-none whitespace-nowrap">
              <span style={{color: '#082f6d'}}>Dallas</span>
              <span className="text-[#f59e0b]">Desi</span>
              <span className="text-[#51ba4f]">Scoop</span>
            </span>
          </Link>
          <p className="text-[11px] md:text-[12px] text-white/60 mt-1.5 max-w-[760px] leading-snug">
            Dallas Desi Scoop is your go-to guide for discovering everything happening across Dallas–Fort Worth. Find Indian, Pakistani, Mediterranean, Middle Eastern and Desi restaurants, food trucks, street food, vegetarian dining, fusion food, halal restaurants, bars and grills, hookah lounges, grocery stores, shopping, entertainment, and more. Discover upcoming Indian and Pakistani events, Bollywood concerts, cultural festivals, comedy shows, fashion events, community gatherings, wedding events, and things to do across DFW. Explore local businesses, professional services, wedding vendors, party venues, deals, restaurant specials, new restaurant openings, and the latest happenings in Dallas, Frisco, Plano, Irving, McKinney, Carrollton, Richardson, Allen, and throughout the Dallas–Fort Worth metroplex.
          </p>
          <div className="flex items-center gap-2 mt-2 text-[12px] text-white/60">
            <MapPin className="w-3.5 h-3.5 shrink-0" /> Dallas–Fort Worth, Texas
          </div>
          <a
            href="https://www.instagram.com/tastebudsbyanubhi"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-2 px-4 py-1 rounded-full text-white text-[12px] font-semibold transition-transform hover:scale-105 active:scale-95"
            style={{ background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)" }}
          >
            <Instagram className="w-4 h-4" /> @tastebudsbyanubhi
          </a>
        </div>

        <div className="border-t border-white/10 mt-3 pt-2 flex flex-col sm:flex-row items-center justify-between gap-1.5">
          <p className="text-[12px] text-white/60 text-center sm:text-left">
            © 2026{' '}
            <span style={{color: '#3B82F6'}}>Dallas</span>
            <span style={{color: '#f59e0b'}}>Desi</span>
            <span style={{color: '#51ba4f'}}>Scoop</span>
            . All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/blog" className="text-[12px] text-white/60 hover:text-white transition-colors">
              Blog
            </Link>
            <p className="text-[12px] text-white/50">
              Powered by <span className="text-white/70 font-medium">Happyspace</span>
            </p>
            <a href="mailto:dallasdesiscoop@gmail.com" className="inline-flex items-center gap-1.5 text-[12px] text-white/60 hover:text-white transition-colors">
              <Mail className="w-3.5 h-3.5" /> dallasdesiscoop@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
